module.exports = __webpack_public_path__ + "files/9df62adcf6a2c72b3d10e3d548caf819.png";